import React from 'react';
import { Wrapper, Content, Line, MLabel, Title } from './styles';


const SectionDetails = ({ clientDetails }) => {

  return (<>
    {clientDetails?.ClientID && (
      <Wrapper>
        <Content>
          <Line>
            <MLabel>お客様：</MLabel>
            <Title>{clientDetails.ClientName || '―'}</Title>
          </Line>
          <Line>
            <MLabel>電話番号：</MLabel>
            {!!clientDetails.Tel && (<div style={{ display: "inline-block" }}
              onClick={(e) => {
                e.stopPropagation();
              }}>
              <a href={`tel:${clientDetails.Tel}`}>{clientDetails.Tel || '―'}</a>
            </div>)}

          </Line>
          <Line>
            <MLabel>カルテ：</MLabel>
            {!!clientDetails.ClientRecordUrl && (
              <div style={{ display: "inline-block" }}
                onClick={(e) => {
                  e.stopPropagation();
                }}>
                <a href={clientDetails.ClientRecordUrl} target="_blank" rel="noreferrer">{"別タブで開く"}</a>
              </div>
            )}
          </Line>
          <Line>
            <MLabel>拠点：</MLabel>
            {clientDetails.BaseName || '―'}
          </Line>
          <Line>
            <MLabel>ランク：</MLabel>
            {clientDetails.ServiceType || '―'}
          </Line>
          <Line>
            <MLabel>価格参照：</MLabel>
            {clientDetails.PriceRefClientName || '―'}
          </Line>
          <Line>
            <MLabel>配送メモ：</MLabel>
            {clientDetails.ClientDeliveryMemo || '―'}
          </Line>
          <Line>
            <MLabel>お客様メモ：</MLabel>
            {clientDetails.ClientMemo || '―'}
          </Line>
          <Line>
            <MLabel>業務に関するメモ：</MLabel>
            <div>{clientDetails.TakeOverMemo || '―'}</div>
          </Line>
          <Line>
            <MLabel>いつも使う商品メモ：</MLabel>
            {clientDetails.UsualItemsMemo || '―'}
          </Line>
        </Content>
      </Wrapper>
    )}
  </>
  )
}

export default SectionDetails;
